<template>
  <div class="myhome-home__event-panel-section">
    <div v-if="events.length > 0" class="grid grid--wide">
      <EventPanel
        :events="events"
        :use-router="true"
        link-type="router"
        :link-color="user.targetCss.colorMod"
      ></EventPanel>
    </div>
    <div v-else class="grid grid--wide">
      <div class="xs-12">
        <h3 class="dea-heading--medium__l">I miei eventi formativi</h3>
        <EmptyEvent :link-color="user.targetCss.colorMod" :parent="user.parent" :student="user.student" />
      </div>
    </div>
  </div>
</template>

<script>
import EmptyEvent from "~/components/books/components/EmptyEvent";
import EventPanel from "~/components/books/components/EventPanel";

export default {
  name: "HomeEvents",
  components: { EmptyEvent, EventPanel },
  props: {
    user: {
      type: Object,
      required: true,
    },
    events: {
      type: Array,
      required: true,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
